<procure-card class="page-not-found">
  <p class="page-not-found__text">
    The page you were looking for was not found. Please make sure that this page actually exists. If it does, try again
    in a few minutes.
  </p>
  <div class="page-not-found__actions">
    <button
      class="page-not-found__button"
      procure-button
      [routerLink]="redirectUrl"
    >
      {{ redirectLabel }}
    </button>
  </div>
</procure-card>
